export default "/images/vendor/flag-icon-css/flags/4x3/eg.svg?b3580df977ae211f31d3c2b1714b8787";